import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import React from 'react';
import useCheckout from '../../Hooks/Checkout/useCheckout';
import { useNavigate } from 'react-router-dom';
import useSiteInfo from '../../Hooks/SiteInfo/useSiteInfo';


const SubscriptionForm = () => {

    const {
        handleAddressId,
        handlePayNow
    } = useCheckout();

    const {
        handleUserSubscribe
    } = useSiteInfo();

    const navigate = useNavigate()
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {}, // return_url hata diya
            redirect: "if_required", // Redirect sirf agar zaroori ho tabhi hoga
        });

        console.log("Payment Result:", result);

        if (result.error) {
            console.log(result.error.message);
        } else if (result.paymentIntent && result.paymentIntent.status === "requires_action") {
            // If further authentication is required
            const { error } = await stripe.confirmCardPayment(result.paymentIntent.client_secret);

            if (error) {
                console.log(error.message);
            } else {
                console.log("Payment successful!");
                handleUserSubscribe()
                navigate("/")
            }
        } else if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
            console.log("Payment successful!", result.paymentIntent);
            handleUserSubscribe()
            navigate("/")
        }
    };


    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />

            <button type='submit' disabled={!stripe} className='mt-3 btn btn-danger w-100'>
                Subscribe Now
            </button>
        </form>
    )
};

export default SubscriptionForm;